import { useEffect, useState } from 'react';

import { productionApi } from 'api/production';

/**
 * Fetches and manages aisles.
 *
 * @returns {Object} - Hook return object
 * @returns {boolean} loading - Whether the aisles are loading
 * @returns {Array} aisles - The list of aisles
 */
export function useAisles() {
    const [loading, setLoading] = useState(true);
    const [aisles, setAisles] = useState();

    useEffect(() => {
        const fetchAisles = async () => {
            try {
                setLoading(true);
                const response = await productionApi.getAisles();
                const aislesData = response.data.categories;
                setAisles(aislesData);
            } catch (error) {
                console.error('Error fetching aisles:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchAisles();
    }, []);

    return { aisles, loading };
}
